module.exports = __webpack_public_path__ + "static/media/25_tn.8513ffb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/25_tn.jpg
// module id = 334
// module chunks = 0